import { render } from "./PortfolioOverviewModal.vue?vue&type=template&id=311e80ba&scoped=true"
import script from "./PortfolioOverviewModal.vue?vue&type=script&lang=js"
export * from "./PortfolioOverviewModal.vue?vue&type=script&lang=js"

import "./PortfolioOverviewModal.vue?vue&type=style&index=0&id=311e80ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311e80ba"]])

export default __exports__